// Bengali Design Patterns and SVGs
import alpona from "../assets/Untitled design (38).png";
import terracotta from "../assets/JustBengali-pattern.png";
import f1 from "../assets/ss.png";
import paisley from "../assets/Untitled design (39).png";
export const bengaliPatterns = {
  // Alpona (traditional Bengali floor art) pattern
  alpona: alpona,
  
  // Paisley pattern
  paisley:paisley,
  
  // Traditional Bengali border pattern
  border: `data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23A0522D' fill-opacity='0.12'%3E%3Cpath d='M30 0l5 10h10l-8 8 3 10-10-6-10 6 3-10-8-8h10z'/%3E%3Cpath d='M30 60l5-10h10l-8-8 3-10-10 6-10-6 3 10-8 8h10z'/%3E%3C/g%3E%3C/svg%3E`,
  
  // Terracotta tile pattern
  terracotta: terracotta,
  
  // Lotus pattern (sacred in Bengali culture)
  lotus: `data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23CD853F' fill-opacity='0.08'%3E%3Cellipse cx='50' cy='70' rx='8' ry='15' transform='rotate(-30 50 70)'/%3E%3Cellipse cx='50' cy='70' rx='8' ry='15' transform='rotate(-15 50 70)'/%3E%3Cellipse cx='50' cy='70' rx='8' ry='15'/%3E%3Cellipse cx='50' cy='70' rx='8' ry='15' transform='rotate(15 50 70)'/%3E%3Cellipse cx='50' cy='70' rx='8' ry='15' transform='rotate(30 50 70)'/%3E%3Cellipse cx='50' cy='70' rx='8' ry='15' transform='rotate(45 50 70)'/%3E%3Cellipse cx='50' cy='70' rx='8' ry='15' transform='rotate(-45 50 70)'/%3E%3Ccircle cx='50' cy='70' r='6'/%3E%3C/g%3E%3C/svg%3E`,

  // Conch shell pattern (shankha - auspicious in Bengali culture)
  conch: `data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23A0522D' fill-opacity='0.1'%3E%3Cpath d='M40 10c-8 0-15 5-18 12-2 4-2 9 0 13 3 7 10 12 18 12s15-5 18-12c2-4 2-9 0-13-3-7-10-12-18-12zm0 5c5 0 9 3 11 7 1 2 1 5 0 7-2 4-6 7-11 7s-9-3-11-7c-1-2-1-5 0-7 2-4 6-7 11-7z'/%3E%3Cpath d='M35 22c0-3 2-5 5-5s5 2 5 5-2 5-5 5-5-2-5-5z'/%3E%3C/g%3E%3C/svg%3E`
};

export const BengaliDecorativeElement = ({ pattern = 'alpona', className = '' }) => {
  return (
    <div 
      className={`absolute inset-0 pointer-events-none ${className}`}
      style={{
        backgroundImage: `url("${bengaliPatterns[pattern]}")`,
        backgroundRepeat: 'repeat',
        opacity: 1
      }}
    />
  );                                                                           
};

// Decorative corner elements
export const BengaliCornerDecor = () => {
  return (
    <>
      {/* Top Left Corner */}
      {/* <div className="absolute top-0 left-0 w-32 h-32 pointer-events-none opacity-20">
        <svg viewBox="0 0 100 100" className="w-full h-full text-amber-700">
          <path fill="currentColor" d="M0,0 Q50,0 50,50 Q0,50 0,0 Z" />
          <circle cx="15" cy="15" r="3" fill="currentColor" />
          <circle cx="30" cy="15" r="2" fill="currentColor" />
          <circle cx="15" cy="30" r="2" fill="currentColor" />
        </svg>
      </div> */}
      
      {/* Top Right Corner */}
      {/* <div className="absolute top-0 right-0 w-32 h-32 pointer-events-none opacity-20 transform scale-x-[-1]">
        <svg viewBox="0 0 100 100" className="w-full h-full text-amber-700">
          <path fill="currentColor" d="M0,0 Q50,0 50,50 Q0,50 0,0 Z" />
          <circle cx="15" cy="15" r="3" fill="currentColor" />
          <circle cx="30" cy="15" r="2" fill="currentColor" />
          <circle cx="15" cy="30" r="2" fill="currentColor" />
        </svg>
      </div> */}
      <div className="absolute top-0 left-10 w-24 opacity-40 animate-bounce">
  <img src={f1} alt="food" />
</div>

<div className="absolute top-20 right-10 w-24 opacity-40 animate-pulse">
  <img src={f1} alt="food" />
</div>
    </>
  );
};

// Decorative divider with Bengali motif
export const BengaliDivider = ({ className = 'opacity-0.5' }) => {
  return (
    <div className={`flex items-center justify-center my-8 ${className}`}>
      <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-600 to-transparent opacity-30"></div>
      <div className="mx-4">
        <svg width="40" height="40" viewBox="0 0 40 40" className="text-amber-700">
          <circle cx="20" cy="20" r="18" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.3" />
          <circle cx="20" cy="20" r="12" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.5" />
          <circle cx="20" cy="20" r="6" fill="none" stroke="currentColor" strokeWidth="1.5" />
          <circle cx="20" cy="20" r="2" fill="currentColor" />
          <circle cx="20" cy="12" r="1.5" fill="currentColor" />
          <circle cx="20" cy="28" r="1.5" fill="currentColor" />
          <circle cx="12" cy="20" r="1.5" fill="currentColor" />
          <circle cx="28" cy="20" r="1.5" fill="currentColor" />
        </svg>
      </div>
      <div className="flex-1 h-px bg-gradient-to-r from-transparent via-amber-600 to-transparent opacity-30"></div>
    </div>
  );
};
